import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchExaminations } from '../../../../store/actions/examinationsActions'
import { PlusIcon } from '@heroicons/react/solid'
import Loader from '../../../../components/elements/Loader'
import Pagination from '../../../../components/elements/Pagination'
import EmptyState from '../../../../components/elements/EmptyState'
import ModalDialog from '../../../../components/layouts/ModalDialog'
// import EditAcademicSession from '../../../../components/partials/academicSessions/EditAcademicSession'
import { fetchAcademicSessions } from '../../../../store/actions/academicSessionsActions'
import AcademicSessionCard from '../../../../components/partials/academicSessions/AcademicSessionCard'
import NewAcademicSession from '../../../../components/partials/academicSessions/NewAcademicSession'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'


const AcademicSessions = () => {
  const dispatch = useDispatch()
  const sessionsSelector = useSelector(state => state.academicSessions)
  const [reload, setReload] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(30);

  useEffect(() => {
    dispatch(fetchAcademicSessions())
    dispatch(fetchExaminations('', page, perPage))
    return () => {
      
    };
  }, [page, perPage, dispatch, reload]);

  const [creatingSession, setCreatingSession] = useState(false);
  // const [activeSession, setActiveSession] = useState(null);

  // const openSession = (session) => {
  //   setActiveSession(session)
  //   setTimeout(() => {
  //     setEditingSession(true)
  //   }, 50);
  // }

  // const closeSession = () => {
  //   setEditingSession(false)
  //   setTimeout(() => {
  //     setActiveSession(null)
  //   }, 50);
  // }

  return (
    <>
      <AdministrationLayout pageTitle="Academic Sessions">
        <div className='w-full'>
          <div className='w-full flex justify-between'>
            <div className='w-9/12'>
              <h3 className='text-lg font-medium'>Vaatia college Academic Sessions </h3>
              <p className='text-sm'>All academic sessions in vaatia college Makurdi. You can create new sessions anytime by clicking on the "Create Session" button</p>
            </div>
            <div>

              <button onClick={()=>{setCreatingSession(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                <PlusIcon className='w-5 h-5' /> Create Session
              </button>

            </div>
          </div>

          {sessionsSelector.loadingAcademicSessions
          ? 
          <Loader /> 
          :
          <>
            {sessionsSelector?.academicSessions?.academicSessions && sessionsSelector?.academicSessions?.academicSessions?.length > 0 
              ? 
                <>
                  <div className='mt-8 mb-5 grid grid-cols-4 gap-8'>
                    {sessionsSelector?.academicSessions?.academicSessions?.map((session, sessionIndex) => (
                      <div key={sessionIndex}>
                        <AcademicSessionCard session={session} />
                      </div>
                    ))}
                  </div> 
                  <Pagination 
                    pagination={{
                      perPage, 
                      page,
                      totalItems: sessionsSelector.academicSessions.total,
                    }} 
                    changePage={setPage} 
                    updatePerPage={setPerPage}
                  />
              </>
              : 
              <div className='h-[300px] w-full flex items-center justify-center'>
                <EmptyState emptyStateText='No examination have been created yet. Click on create examination above to create a new one'></EmptyState>
              </div>
            }
          </>}

        </div>
      </AdministrationLayout>

      <ModalDialog
        shown={creatingSession} 
        closeFunction={()=>{setCreatingSession(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create Academic Session`}
        dialogTitle='Create a new academic session'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <NewAcademicSession 
          reload={()=>setReload(reload+1)}
          closeFunction={()=>{setCreatingSession(false)}} 
          // session={activeSession}
        />
      </ModalDialog>

      {/* {activeSession && }  */}
    </>
  )
}


export default AcademicSessions